import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from './providers/api.service';
import { NavService } from './providers/nav.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';

export enum pageFilters { chalkBoard, trends, last5, myManager }
export enum headerMenu { account = 1, plan, preferences, payment, confirm }
export enum platformList { DraftKings = 1, FanDuel }
export enum sportList { NFL = 1, NBA, MLB }
export class SideBarToolTip {
  ExcludeHighAndLowValues = ' Example: The 3 game average will look at the last 5 games, and then exclude the high and low values. \nThis eliminates potential anomalies, and returns a truer average.';
}

export class Constants {
  season = 'Season ';
}

export class NFLToolTip {
  VegasOdds = 'Implied Team Total uses the spread and over/under to determine \nhow many points each team should score';
  FanPts = 'Fantasy Points';
  Value = 'Fantasy Points/(Salary/1000)';
  HighScore = 'Highest Fantasy Point Total in Previous Games';
  LowScore = 'Lowest Fantasy Point Total in Previous Games';
  Snap = 'Percentage of Total Offensive Snaps Played';
  PassYds = 'Passing Yds';
  PassTD = 'Passing Touchdowns';
  QBRat = 'Quarterback Rating';
  RushAtt = 'Rushing Attempts';
  RushYds = 'Rushing Yards';
  RushTD = 'Rushing Touchdowns';
  Tgts = 'Targets';
  Rec = 'Receptions';
  RecYds = 'Receiving Yards';
  RecTD = 'Receiving Touchdowns';
  TeamRankScoring = 'Points Per Game';
  TeamRankPassYds = 'Passing Yards Per Game';
  TeamRankRushYds = 'Rushing Yards Per Game';
  TeamRankPlaysPerGm = 'Number of Offensive Plays Per Game';
  TeamRankRZAtt = 'Red Zone Attempts Per Game';
  TeamRank3rdDownConv = '3rd Down Conversions Per Game';
}

export class NBAToolTip {
  VegasOdds = 'Implied Team Total uses the spread and over/under to determine \nhow many points each team should score.';
  FanPts = 'Fantasy Points';
  Value = 'Fantasy Points/(Salary/1000)';
  HighScore = 'Highest fantasy point total in previous games';
  LowScore = 'Lowest fantasy point total in previous games';
  Min = 'Minutes Played';
  FPPM = 'Fantasy Points Per Minute';
  Usage = '100*((FGA+0.44*FTA+TOV)*(Team Minutes/5))/(Minutes*(Team FGA+0.44*Team FTA+Team TOV))';
  PlayerEfficiencyRating = '((FG*85.91)+(STL*53.897)+(3P*51.757)+(FT*46.845)+(BLK*39.19)+\n(ORB*39.19)+(AST*34.677)+(DRB*14.707)-(PF*17.174)-((FTA-FT)*20.091)-((FGA-FG)*39.19)-(TOV*53.897))*(1/Minutes)';
  Pts = 'Points';
  FG = 'Field Goals';
  FGA = 'Field Goal Attempts';
  FGPe = 'Field Goal Percentage';
  threeP = '3-Pointers';
  threePA = '3-Point Attempts';
  threePe = '3-Point Percentage';
  FT = 'Free Throws';
  FTA = 'Free Throw Attempts';
  FTPe = 'Free Throw Percentage';
  TRB = 'Total Rebounds';
  ORB = 'Offensive Rebounds';
  DRB = 'Defensive Rebounds';
  AST = 'Assists';
  STL = 'Steals';
  BLK = 'Blocks';
  TOV = 'Turnovers';
  PF = 'Personal Fouls';
  Rest = 'Days since last game played';
  TeamRankPts = 'Points Per Game';
  TeamRankPace = 'Possessions Per Game';
  TeamRankPtsinPaint = 'Points in the Paint Per Game';
  TeamRankFastbreakPts = 'Fastbreak Points Per Game';
  TeamRankofPtsfrom2s = 'Percentage of Points from 2-Point Field Goals';
  TeamRankofPtsfrom3s = 'Percentage of Points from 3-Point Field Goals';
  TeamRank3sMade = 'Total 3-pointers Made Per Game';
  TeamRankTRB = 'Total Rebounds Per Game';
  TeamRankBLK = 'Blocks Per Game';
  TeamRankSTL = 'Steals Per Game';
  TeamRankAST = 'Assists Per Game';
  TeamRankTOV = 'Turnovers Per Game';
  TeamRankFouls = 'Fouls Per Game';
}

export class MLBBatterToolTip {
  VegasOdds = 'Team Odds to Win and Over/Under';
  Weather = 'Game time weather conditions';
  FanPts = 'Fantasy Points';
  Value = 'Fantasy Points/(Salary/1000)';
  HighScore = 'Highest Fantasy Point Total in Previous Games';
  LowScore = 'Lowest Fantasy Point Total in Previous Games';
  BA = 'Batting Average';
  OBP = 'On-Base Percentage';
  SLG = 'Slugging Percentage';
  OPS = 'On-Base Plus Slugging';
  wOBA = 'Weighted On-Base Average';
  ISO = 'Isolated Power';
  BABIP = 'Batting Average on Balls in Play';
  CT = 'Contact Percentage';
  RC = 'Runs Created';
  BBK = 'Walk-To-Strikeout Ratio';
  Walk = 'Walk Percentage';
  IP = 'Innings Pitched';
  SO = 'Strikeouts';
  ERA = 'Earned Run Average';
  WHIP = 'Walks and Hits Per Inning';
  FIP = 'Fielding Independent Pitching';
  K9 = 'Strikeouts Per 9 Innings';
  BB9 = 'Walks Per 9 Innings';
  KBB = 'Strikeout-To-Walk Ratio';
  HR9 = 'Home Runs Per 9 Innings';
}

export class MLBPitcherToolTip {
  VegasOdds = 'Team Odds to Win and Over/Under';
  Weather = 'Game time weather conditions';
  FanPts = 'Fantasy Points';
  Value = 'Fantasy Points/(Salary/1000)';
  HighScore = 'Highest Fantasy Point Total in Previous Games';
  LowScore = 'Lowest Fantasy Point Total in Previous Games';
  IP = 'Innings Pitched';
  SO = 'Strikeouts';
  ERA = 'Earned Run Average';
  WHIP = 'Walks and Hits Per Inning';
  FIP = 'Fielding Independent Pitching';
  K9 = 'Strikeouts Per 9 Innings';
  BB9 = 'Walks Per 9 Innings';
  KBB = 'Strikeout-To-Walk Ratio';
  HR9 = 'Home Runs Per 9 Innings';
}

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  managePlayerCount = 0;
  loginUserDetails: any = JSON.parse(localStorage.getItem('userDetails'));
  clearFilters = new Subject();

  defaultLimit = '10';
  limitOptions = [
    { value: '5', name: 'Last 5' },
    { value: '10', name: 'Last 10' },
    { value: '20', name: 'Last 20' },
  ];

  NFLMinMaxValue = [
    { value: '33', name: 'odds_implied_team_total_max' },
    { value: '17', name: 'odds_implied_team_total_min' },
    { value: '-10', name: 'odds_spread_max' },
    { value: '10', name: 'odds_spread_min' },
    { value: '56', name: 'odds_ou_max' },
    { value: '37', name: 'odds_ou_min' },

    { value: '40', name: 'fantasy_points_max' },
    { value: '0', name: 'fantasy_points_min' },

    { value: '6', name: 'fantasy_value_max' },
    { value: '0', name: 'fantasy_value_min' },

    { value: '40', name: 'high_score_max' },
    { value: '0', name: 'high_score_min' },


    { value: '40', name: 'low_score_max' },
    { value: '0', name: 'low_score_min' },


    { value: '95', name: 'off_snap_max' },
    { value: '20', name: 'off_snap_min' },


    { value: '450', name: 'pass_yds_max' },
    { value: '0', name: 'pass_yds_min' },


    { value: '5', name: 'pass_td_max' },
    { value: '0', name: 'pass_td_min' },

    { value: '140', name: 'qr_rating_max' },
    { value: '0', name: 'qr_rating_min' },


    { value: '30', name: 'rush_att_max' },
    { value: '0', name: 'rush_att_min' },

    { value: '200', name: 'rush_yds_max' },
    { value: '0', name: 'rush_yds_min' },


    { value: '3', name: 'rush_td_max' },
    { value: '0', name: 'rush_td_min' },


    { value: '18', name: 'tgts_max' },
    { value: '0', name: 'tgts_min' },


    { value: '15', name: 'rec_max' },
    { value: '0', name: 'rec_min' },

    { value: '200', name: 'rec_yds_max' },
    { value: '0', name: 'rec_yds_min' },


    { value: '3', name: 'rec_td_max' },
    { value: '0', name: 'rec_td_min' },
  ];


  NBAMinMaxValue = [
    { value: '130', name: 'odds_implied_team_total_max' },
    { value: '90', name: 'odds_implied_team_total_min' },
    { value: '-10', name: 'odds_spread_max' },
    { value: '10', name: 'odds_spread_min' },
    { value: '240', name: 'odds_ou_max' },
    { value: '190', name: 'odds_ou_min' },

    { value: '50', name: 'fantasy_points_max' },
    { value: '0', name: 'fantasy_points_min' },

    { value: '6', name: 'fantasy_value_max' },
    { value: '0', name: 'fantasy_value_min' },

    { value: '50', name: 'high_score_max' },
    { value: '0', name: 'high_score_min' },

    { value: '50', name: 'low_score_max' },
    { value: '0', name: 'low_score_min' },


    { value: '40', name: 'min_max' },
    { value: '0', name: 'min_min' },

    { value: '1.5', name: 'fantasy_points_per_min_max' },
    { value: '0', name: 'fantasy_points_per_min_min' },

    { value: '40', name: 'usage_max' },
    { value: '0', name: 'usage_min' },

    { value: '40', name: 'pts_max' },
    { value: '0', name: 'pts_min' },

    { value: '10', name: 'fg_max' },
    { value: '0', name: 'fg_min' },

    { value: '20', name: 'fga_max' },
    { value: '0', name: 'fga_min' },

    { value: '70', name: 'fgp_max' },
    { value: '0', name: 'fgp_min' },

    { value: '8', name: 'threep_max' },
    { value: '0', name: 'threep_min' },

    { value: '12', name: 'threepa_max' },
    { value: '0', name: 'threepa_min' },

    { value: '50', name: 'threepp_max' },
    { value: '0', name: 'threepp_min' },

    { value: '10', name: 'ft_max' },
    { value: '0', name: 'ft_min' },

    { value: '15', name: 'fta_max' },
    { value: '0', name: 'fta_min' },

    { value: '90', name: 'ftp_max' },
    { value: '0', name: 'ftp_min' },


    { value: '15', name: 'trb_max' },
    { value: '0', name: 'trb_min' },

    { value: '5', name: 'org_max' },
    { value: '0', name: 'org_min' },

    { value: '10', name: 'drb_max' },
    { value: '0', name: 'drb_min' },

    { value: '8', name: 'ast_max' },
    { value: '0', name: 'ast_min' },

    { value: '5', name: 'stl_max' },
    { value: '0', name: 'stl_min' },

    { value: '5', name: 'blk_max' },
    { value: '0', name: 'blk_min' },

    { value: '0', name: 'tov_max' },
    { value: '5', name: 'tov_min' },

    { value: '0', name: 'pf_max' },
    { value: '5', name: 'pf_min' },
  ];

  MLBMinMaxValueBatting = [

    { value: '-350', name: 'odds_implied_team_total_max' },
    { value: '350', name: 'odds_implied_team_total_min' },
    { value: '-350', name: 'odds_spread_max' },
    { value: '350', name: 'odds_spread_min' },
    { value: '11', name: 'odds_ou_max' },
    { value: '6', name: 'odds_ou_min' },

    { value: '25', name: 'fantasy_points_max' },
    { value: '0', name: 'fantasy_points_min' },

    { value: '10', name: 'fantasy_value_max' },
    { value: '0', name: 'fantasy_value_min' },

    { value: '40', name: 'high_score_max' },
    { value: '0', name: 'high_score_min' },

    { value: '10', name: 'low_score_max' },
    { value: '0', name: 'low_score_min' },

    { value: '0.400', name: 'avg_max' },
    { value: '0.100', name: 'avg_min' },

    { value: '0.500', name: 'obp_max' },
    { value: '0.200', name: 'obp_min' },


    { value: '0.700', name: 'slg_max' },
    { value: '0.200', name: 'slg_min' },

    { value: '1.200', name: 'ops_max' },
    { value: '0.350', name: 'ops_min' },


    { value: '0.370', name: 'woba_max' },
    { value: '0.300', name: 'woba_min' },

    { value: '0.600', name: 'iso_max' },
    { value: '0.100', name: 'iso_min' },

    { value: '0.500', name: 'babip_max' },
    { value: '0.100', name: 'babip_min' },

    { value: '0.900', name: 'ct_max' },
    { value: '0.500', name: 'ct_min' },

    { value: '1.000', name: 'bbk_max' },
    { value: '0.200', name: 'bbk_min' },

    { value: '0.200', name: 'walk_max' },
    { value: '0.050', name: 'walk_min' }
  ];

  MLBMinMaxValuePiting = [

    { value: '-350', name: 'odds_implied_team_total_max' },
    { value: '350', name: 'odds_implied_team_total_min' },
    { value: '-350', name: 'odds_spread_max' },
    { value: '350', name: 'odds_spread_min' },
    { value: '11', name: 'odds_ou_max' },
    { value: '6', name: 'odds_ou_min' },

    { value: '40', name: 'fantasy_points_max' },
    { value: '0', name: 'fantasy_points_min' },

    { value: '5', name: 'fantasy_value_max' },
    { value: '0', name: 'fantasy_value_min' },

    { value: '60', name: 'high_score_max' },
    { value: '0', name: 'high_score_min' },

    { value: '15', name: 'low_score_max' },
    { value: '0', name: 'low_score_min' },
    /* pitcher */
    { value: '7', name: 'ip_max' },
    { value: '1', name: 'ip_min' },

    { value: '10', name: 'so_max' },
    { value: '0', name: 'so_min' },

    { value: '0', name: 'era_max' },
    { value: '9', name: 'era_min' },

    { value: '1.1', name: 'whip_max' },
    { value: '1.5', name: 'whip_min' },

    { value: '2', name: 'fip_max' },
    { value: '7', name: 'fip_min' },

    { value: '15', name: 'k9_max' },
    { value: '5', name: 'k9_min' },

    { value: '0', name: 'bb9_max' },
    { value: '9', name: 'bb9_min' },

    { value: '9', name: 'kbb_max' },
    { value: '1', name: 'kbb_min' },

    { value: '0', name: 'hr9_max' },
    { value: '5', name: 'hr9_min' }
  ];


  constructor(
    private SpinnerService: NgxSpinnerService,
    private api: ApiService,
    private toastr: ToastrService,
    private navService: NavService,
    private route: Router,
  ) { }

  getColorCode(array: any[], obj: any, isReverseOrder = false) {
    obj.key = obj.key.split('.');

    /*If reverse order is set or rank is set than get min max from current column*/
    let max = 0;
    let min = 0;
    if (isReverseOrder || (obj.type && obj.type == 'rank')) {
      obj.key.splice(0, 1);
      if (array && array.length > 0) {
        // const valuesArray = array.map(x => obj.key.reduce((a, prop) => a[prop], x));
        const valuesArray = [];
        array.forEach(element => {
          let value = obj.key.reduce((a, prop) => a[prop], element);
          if (value != null) {
            value = Number(String(value).replace('%', ''));
            valuesArray.push(value);
          } else {
            valuesArray.push(0);
          }
        });
        if (valuesArray && valuesArray.length > 0) {
          max = Math.max(...valuesArray);
          min = Math.min(...valuesArray);
        }
      } else {
        return '';
      }
    } else {
      let MinMaxArr = [];
      if (obj.sport == 'NFL') {
        MinMaxArr = this.NFLMinMaxValue;
      } else if (obj.sport == 'NBA') {
        MinMaxArr = this.NBAMinMaxValue;
      } else if (obj.sport == 'MLB') {
        if (obj.player_type == 'batting') {
          MinMaxArr = this.MLBMinMaxValueBatting;
        } else if (obj.player_type == 'pitching') {
          MinMaxArr = this.MLBMinMaxValuePiting;
        }
      }
      if (obj.key[2] == 'vegas_odds') {
        obj.key[2] = obj.key[3];
      }
      max = MinMaxArr.find(m => m.name == obj.key[2] + '_max').value;
      min = MinMaxArr.find(m => m.name == obj.key[2] + '_min').value;
    }

    if (obj.value != null) {
      obj.value = Number(String(obj.value).replace('%', ''));
      return this.getColorForPercentage(obj.value, min, max, isReverseOrder);
    } else {
      // Return same color if value is null
      obj.value = 0;
      return true;
    }
  }


  getLast5ColorCode(value, sportId, categoryName) {
    let min = 0;
    let max = 0;
    if (sportId == 1) {
      min = -10;
      max = 10;
    } else if (sportId == 2 && categoryName == 'fantasy_points') {
      min = -15;
      max = 15;
    } else if (sportId == 2 && categoryName == 'fantasy_points_per_min') {
      min = -0.5;
      max = 0.5;
    } else if (sportId == 3) {
      min = -15;
      max = 15;
    }
    return this.getColorForPercentage(value, min, max, false);
  }
  private getColorForPercentage(pct, min, max, isReverseOrder) {
    let percentColors = [];
    if (isReverseOrder) {
      percentColors = [
        { pct: 0.0, color: { r: 0x00, g: 0xff, b: 0 } },
        { pct: 0.5, color: { r: 0xff, g: 0xff, b: 0 } },
        { pct: 1.0, color: { r: 0xff, g: 0x00, b: 0 } },
      ];
    } else {
      percentColors = [
        { pct: 0.0, color: { r: 0xff, g: 0x00, b: 0 } },
        { pct: 0.5, color: { r: 0xff, g: 0xff, b: 0 } },
        { pct: 1.0, color: { r: 0x00, g: 0xff, b: 0 } },
      ];
    }
    pct = isNaN(((pct - min) / (max - min))) ? 0 : ((pct - min) / (max - min));
    let i = 0;
    for (i = 1; i < percentColors.length - 1; i++) {
      if (pct < percentColors[i].pct) {
        break;
      }
    }
    const lower = percentColors[i - 1];
    const upper = percentColors[i];
    const range = upper.pct - lower.pct;
    const rangePct = (pct - lower.pct) / range;
    const pctLower = 1 - rangePct;
    const pctUpper = rangePct;
    const color = {
      r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
      g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
      b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper)
    };
    return 'rgb(' + [color.r, color.g, color.b, 0.50].join(',') + ')';
  }

  getSelectedLimit(limit: string) {
    if (limit) {
      return this.limitOptions.find(m => m.value == limit).name;
    } else {
      return '';
    }
  }

  updatefiltersSelection(filters: any, _tab?: string) {
    let userDetail = JSON.parse(localStorage.getItem('userDetails'));
    if (userDetail) {
      userDetail['slateSelection'] = filters;
      localStorage.setItem('userDetails', JSON.stringify(userDetail));
      filters && this.setPlayerCount();
    }
  }

  getFilter(_tab: string) {
    let userDetail = JSON.parse(localStorage.getItem('userDetails'));
    if (userDetail) {
      return userDetail['slateSelection'];
    }
    return null;
  }

  setPlayerCount() {
    let userDetail = JSON.parse(localStorage.getItem('userDetails'));
    if (userDetail['slateSelection']) {
      let slate = userDetail['slateSelection'].slate;
      if (userDetail && (userDetail[slate + '_count'] !== null || userDetail[slate + '_count'] !== undefined)) {
        this.managePlayerCount = userDetail[slate + '_count'];
        return userDetail[slate + '_count'];
      }
    }
  }

  updateManagerPlayerCount(count: number) {
    // this.managePlayerCount = count;
    this.loginUserDetails.managePlayerCount = count;
    let userDetail = JSON.parse(localStorage.getItem('userDetails'));
    if (userDetail) {
      userDetail.managePlayerCount = count;
    } else {
      userDetail = this.loginUserDetails
    }
    localStorage.setItem('userDetails', JSON.stringify(userDetail));
  }

  updateManagerPlayerCountAll(slate: any, count: number) {
    this.loginUserDetails[slate + '_count'] = count;
    let userDetail = JSON.parse(localStorage.getItem('userDetails'));
    if (userDetail) {
      userDetail[slate + '_count'] = count;
    }
    localStorage.setItem('userDetails', JSON.stringify(userDetail));
  }

  removeManagerPlayerCountAll(slate: any) {
    this.loginUserDetails[slate + '_count'] = this.loginUserDetails[slate + '_count'] - 1;
    let userDetail = JSON.parse(localStorage.getItem('userDetails'));
    if (userDetail) {
      userDetail[slate + '_count'] = this.loginUserDetails[slate + '_count'];
    }
    localStorage.setItem('userDetails', JSON.stringify(userDetail));
    this.setPlayerCount();
  }

  addManagerPlayerCountAll(slate: any) {

    this.loginUserDetails[slate + '_count'] =this.loginUserDetails[slate + '_count'] ? this.loginUserDetails[slate + '_count'] + 1 : 1;
    let userDetail = JSON.parse(localStorage.getItem('userDetails'));
    if (userDetail) {
      userDetail[slate + '_count'] = this.loginUserDetails[slate + '_count'];
    }
    localStorage.setItem('userDetails', JSON.stringify(userDetail));
    this.setPlayerCount();
  }

  addPlayerForManager(item): Promise<boolean> {
    return new Promise(resolve => {
      this.loginUserDetails = JSON.parse(localStorage.getItem('userDetails'));
      if (this.loginUserDetails.isLogin) {
        const ids = {
          user_id: this.loginUserDetails.user_id,
          player_id: item.player_id,
          slates_id: item.slates_id
        };
        this.SpinnerService.show();
        this.api.addPlayerToManager(ids).subscribe(data => {
          this.SpinnerService.hide();
          if (data && data.code == 100) {
            this.addManagerPlayerCountAll(ids.slates_id);
            this.toastr.success('Player Added successfully', 'Success');
            resolve(true);
          } else {
            // console.log('Add Player From Manager Api :' + data.message);
            resolve(false);
          }
        }, (err) => {
          this.SpinnerService.hide();
          // console.log('something went wrong');
          resolve(false);
        });
      } else {
        alert('You need to login compulsory');
        resolve(false);
      }
    });
  }

  onLogout(): Promise<boolean> {
    return new Promise(resolve => {
      Swal.fire({
        title: 'Are you sure you want to Logout?',
        text: '',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          localStorage.clear();
          // this.authService.signOut(true);
          this.navService.changeNav('');
        }
      });
    });
  }

  userToSignup(): Promise<boolean> {
    return new Promise(resolve => {
      Swal.fire({
        title: 'Please Login',
        text: '',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          localStorage.clear();
          this.navService.changeNav('');
        }
      });
    });
  }

  onRemovePlayer(item): Promise<boolean> {
    return new Promise(resolve => {
      Swal.fire({
        title: 'Are you sure want to Remove?',
        text: '',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.RemovePlayerApi(item).then(res => {
            resolve(res);
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          resolve(true);
        }
      });
    });
  }

  RemovePlayerApi(item): Promise<boolean> {
    return new Promise(resolve => {
      const ids = {
        user_id: (this.loginUserDetails && this.loginUserDetails.user_id) ? this.loginUserDetails.user_id : '',
        player_id: item.player_id,
      };
      this.SpinnerService.show();
      this.api.removePlayerFormManager(ids).subscribe(data => {
        this.SpinnerService.hide();
        if (data && data.code == 100) {
          this.removeManagerPlayerCountAll(item.slates_id);
          // console.log('Player Removed successfully');
          resolve(false);
        } else {
          // console.log('Remove Player From Manager Api :' + data.message);
          resolve(true);
        }
      }, (err) => {
        this.SpinnerService.hide();
        // console.log('something went wrong');
        resolve(true);
      });
    });
  }

  addCommas(event) {
    const parts = event.target.value.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    event.target.value = parts[0];
    event.preventDefault();
    // return parts.join('.');
  }

  getManagerCount(): Promise<boolean> {
    return new Promise(resolve => {
      let userDet = JSON.parse(localStorage.getItem('userDetails'));
      let obj = {
        user_id: userDet.user_id,
        accessToken: userDet.accessToken
      };
      this.SpinnerService.show();
      this.api.getManagerCount(obj).subscribe(data => {
        this.SpinnerService.hide();
        if (data && data.code == 100) {
          data.userManagerPlayerList.forEach((c) => {
            this.updateManagerPlayerCountAll(c.slates_id, c.playerCount);
          })
          resolve(false);
        } else {
          resolve(true);
        }
      }, (err) => {
        this.SpinnerService.hide();
        resolve(true);
      });
    });
  }
}
